import { zAttribute } from "src/types/ZAttribute";
import { zGroup } from "src/types/ZGroup";
import { z } from "zod";
import { zPermissionsList } from "./Permission";
import { zUid } from "./zUid";
import { zDisplayId } from "./ZDisplayId";

// Соответствует ObjectDto в сваггере.
// Служит для не только для основной цели (представлять объект в редакторе объектно-атрибутивной модели),
// но и для описания Ролей.

export const zObjectItem = z.object({
  id: zUid,
  name: z.string(),
  displayId: zDisplayId.nullish(),
  displayRoleId: zDisplayId.nullish(),
  disableVersionAudit: z.boolean().nullish(),
  groups: zGroup.array().nullable().optional(),
  attributes: zAttribute.array(),
  permissions: zPermissionsList.nullable().optional(),
  roleId: zUid.nullable().optional(), // Похоже, что он нужен только в тех случаях, когда эта структура описывает Роль. А для объектов =0
  allowFileImport: z.boolean().optional(),
  allowMassDelete: z.boolean().optional(),
});
export type ZObjectItem = z.infer<typeof zObjectItem>;
